<template>
  <div class="landing-page">
    <div class="background"></div>
    <AnimatedLogo @animation-complete="delayShowButton" />
    
    
    <button :class="{ fadeIn: isButtonVisible }" @click="enterApp">Enter App</button>
  </div>
</template>

<script>
import AnimatedLogo from './AnimatedLogo.vue';




export default {
  name: 'LandingPage',
  components: {
    AnimatedLogo,
  },
  data() {
    return {
      isButtonVisible: false, // Initially hide the button
      
    };
  },
  methods: {
    delayShowButton() {
      setTimeout(() => {
        this.isButtonVisible = true; // Show the button after 1 second delay
      }, 1000); // 1 second delay
    },
    enterApp() {
      console.log('Enter App button clicked');
      this.$router.push('/login')
        .then(() => {
          console.log('Navigation to /dashboard successful');
        })
        .catch((err) => {
          console.error('Navigation error:', err);
        });
    }
  }
};
</script>

<style scoped>
.landing-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  position: relative;
  background-color: #060714;
  flex-direction: column;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, #2d003e, #370049, #4a005e, #5c0073, #72008a);
  animation: pulse 3s infinite;
  z-index: -1;
}

button {
  z-index: 1;
  padding: 10px 20px;
  font-size: 18px;
  background-color: #008a67cb;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 1s ease-in; /* Fade-in effect */
  margin-bottom: 1in; /* Move the button up by 1 inch */
}

button.fadeIn {
  opacity: 1; /* Button becomes fully visible */
}

button:hover {
  background-color: #444848;
}

.pablo-buddha.fadeIn {
  opacity: 1;
}


.pablo-buddha {
  width: 140px;              /* or whatever you chose */
  opacity: 0;
  transition: opacity 1.6s ease;
  filter: drop-shadow(0 0 22px rgba(99, 102, 241, 0.45));
  margin: 12px 0;
  margin-bottom: 40px;

  /* 🔥 THIS IS THE IMPORTANT PART */
  mask-image: radial-gradient(
    ellipse at center,
    rgba(0,0,0,1) 55%,
    rgba(0,0,0,0.9) 65%,
    rgba(0,0,0,0.6) 75%,
    rgba(0,0,0,0) 100%
  );
}
</style>
